// extracted by mini-css-extract-plugin
export default {"wrapper":"Tz-z","button":"Uz-z","alternate":"Vz-z","disabled":"Wz-z","paymentWarning":"Xz-z","fadeIn":"Yz-z"};